import { createSlice } from "@reduxjs/toolkit";

const previousNewsletterReducer = createSlice({
  name: "previousNewsletter",
  initialState: {
    previousNewsletterDetails: null,
    previousNewsletter: null,
    previousNewsletterList: null,
    previousNewsletterMetadata: null,
    previousNewsletterError: "",
    listLoading: false,
  },
  reducers: {
    setPreviousNewsletterDetail: (state, action) => {
      state.previousNewsletterDetails = action.payload.data;
      state.previousNewsletterError = null;
    },
    setPreviousNewsletterList: (state, action) => {
      state.previousNewsletterList = action.payload.data;
      state.previousNewsletterError = null;
    },
    setListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    setMetadata: (state, action) => {
      state.previousNewsletterMetadata = action.payload.meta;
    },
    setPreviousNewsletter: (state, action) => {
      state.previousNewsletter = action.payload.data;
      state.previousNewsletterError = null;
    },
    setPreviousNewsletterError: (state, action) => {
      state.previousNewsletterError = action.payload.error;
    },
    cleanPreviousNewsletterState: (state) => {
      state = previousNewsletterReducer.getInitialState();
    },
  },
});

export const {
  setPreviousNewsletterDetail,
  setPreviousNewsletterList,
  setPreviousNewsletterError,
  setPreviousNewsletter,
  setMetadata,
  cleanPreviousNewsletterState,
  setListLoading,
} = previousNewsletterReducer.actions;

export default previousNewsletterReducer.reducer;